import { createSlice } from "@reduxjs/toolkit";
import {uploadImage} from "./thunks"


const uploardSlice = createSlice({
  name: 'dietPlan/uploadImage',
  initialState: {
   
    uploadedImageUrl: null, // Stocke l'URL de l'image uploadée
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      // Gestion des états pour GetAllDietPlanByUser
     

      // Gestion des états pour uploadImage
      .addCase(uploadImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadImage.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadedImageUrl = action.payload.fileUrl; // Stocke l'URL de l'image
      })
      .addCase(uploadImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Erreur inconnue';
      });
  },
});

export default uploardSlice.reducer;